// extracted by mini-css-extract-plugin
export default {"importCsvCard":"AddProd_importCsvCard__Tl0U3","addProductBtnContainer":"AddProd_addProductBtnContainer__WWI5f"};